import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { kisiQueryKeys } from "./kisiQueryKeys";

export function useQueryKisiGroupMappings({
  api,
  enabled,
}: {
  api: ApiType;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: kisiQueryKeys.groupMappings(),
    queryFn: async () => (await api.kisiApi.fetchGroupMappings()).data,
    enabled: enabled,
  });
}
